import { Autocomplete, ListItem, ListItemText, TextField } from '@mui/material'
import React, { useMemo, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetInventoryLocationsQuery } from '../../../redux/api'
import { InventoryPartEntry } from '../../../sdk'
import { containsIgnoreCase } from '../../../utils/containsIgnoreCase/containsIgnoreCase'
export interface ModifiedOption {
  name: string
  inputValue?: string
}
export const LocationCreatableAutoComplete = ({
  defaultValues,
  selectedLocation,
  setSelectedLocation
}: {
  defaultValues: InventoryPartEntry | undefined
  selectedLocation: ModifiedOption | undefined
  setSelectedLocation: React.Dispatch<
    React.SetStateAction<ModifiedOption | undefined>
  >
}) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const initialLocation = defaultValues?.info!.location
    ? {
        name: defaultValues?.info!.location
      }
    : undefined
  const [input, setInput] = useState(initialLocation?.name || '')

  const { data: inventoryLocations } = useGetInventoryLocationsQuery({
    authorization: accessToken,
    shop: shopId
  })

  const exLocations: ModifiedOption[] = useMemo(
    () => (inventoryLocations || []).map((l) => ({ name: l })),
    [inventoryLocations]
  )

  return (
    <Autocomplete
      id="locationSearch"
      getOptionLabel={(option) => option.inputValue || option.name!}
      options={exLocations}
      autoComplete
      value={selectedLocation}
      loading={false}
      onChange={(
        event: React.SyntheticEvent,
        newValue: ModifiedOption | null
      ) => {
        if (!newValue) {
          setSelectedLocation(undefined)
        } else {
          setSelectedLocation(newValue)
        }
      }}
      onInputChange={(event, newInputValue) => {
        setInput(newInputValue)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select a Location"
          fullWidth
          variant="standard"
        />
      )}
      renderOption={(props, option) => {
        return (
          <ListItem sx={{ padding: 0 }} {...props}>
            <ListItemText primary={option.name} />
          </ListItem>
        )
      }}
      noOptionsText={
        input && input.length < 1
          ? 'Please enter at least 1 character to search'
          : 'No options found'
      }
      fullWidth
      filterOptions={(options, params) => {
        const { inputValue } = params
        const filtered = options.filter((o) =>
          containsIgnoreCase(o.name, inputValue)
        )
        const isExisting = options.some((option) => inputValue === option.name)
        if (inputValue !== '' && !isExisting) {
          filtered.push({
            name: `Add "${input}"`,
            inputValue: input
          })
        }
        return filtered
      }}
    />
  )
}
